
export let deposit=(amount)=>{
    return{
        type:"deposit",
        payload:amount
    }
}

export const withdraw=(withdraw)=>{
   return{
    type:"withdraw",
    payload:withdraw
   }
}

export const nameupdate=(nameupdate)=>{
    return{
        type:"nameupdate",
        payload:nameupdate
    }
}

export const mobileupdate=(mobileupdate)=>{
    return{
        type:"mobileupdate",
        payload:mobileupdate
    }
}

export const reset=(reset)=>{
    return{
        type:"reset"
    }
}

